// extracted by mini-css-extract-plugin
module.exports = {"section":"politics_section__3BbGv","wrap":"politics_wrap__2XP09"};